export const FETCH_STUDENT_RESULTS_REQUEST = 'FETCH_STUDENT_RESULTS_REQUEST';
export const FETCH_STUDENT_RESULTS_SUCCESS = 'FETCH_STUDENT_RESULTS_SUCCESS';
export const FETCH_STUDENT_RESULTS_FAILURE = 'FETCH_STUDENT_RESULTS_FAILURE';
export const FETCH_CERTIFICATES_REQUEST = 'STUDENT_FETCH_CERTIFICATES_REQUEST';
export const FETCH_CERTIFICATES_SUCCESS = 'STUDENT_FETCH_CERTIFICATES_SUCCESS';
export const FETCH_CERTIFICATES_FAILURE = 'STUDENT_FETCH_CERTIFICATES_FAILURE';
export const DOWNLOAD_CERTIFICATE_REQUEST = 'STUDENT_DOWNLOAD_CERTIFICATE_REQUEST';
export const DOWNLOAD_CERTIFICATE_SUCCESS = 'STUDENT_DOWNLOAD_CERTIFICATE_SUCCESS';
export const DOWNLOAD_CERTIFICATE_FAILURE = 'STUDENT_DOWNLOAD_CERTIFICATE_FAILURE';